// Yandex.Metrika typed event API.
// Gated on NEXT_PUBLIC_YM_ID env. On server (no window) all functions = no-op.

type YMEventParams = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    ym?: (id: number, action: string, ...args: unknown[]) => void;
  }
}

const COUNTER_ID = Number(process.env.NEXT_PUBLIC_YM_ID || 0);

function reachGoal(target: string, params?: YMEventParams) {
  if (typeof window === 'undefined' || !window.ym || !COUNTER_ID) return;
  window.ym(COUNTER_ID, 'reachGoal', target, params);
}

export type CtaLocation =
  | 'hero_primary'
  | 'hero_secondary'
  | 'navbar'
  | 'sticky_mobile'
  | 'solution'
  | 'cases_repeat'
  | 'cases_index'
  | 'services_recon'
  | 'services_pilot'
  | 'services_transform'
  | 'guarantee'
  | 'final'
  | 'case_page'
  | 'magnet_page';

export const track = {
  ctaClick: (location: CtaLocation) => {
    reachGoal('cta_click', { location });
  },
  formStart: (form: 'lead' | 'lead_magnet' = 'lead') => {
    reachGoal('lp_form_start', { form });
  },
  formSubmit: (params: {
    form: 'lead' | 'lead_magnet';
    segment?: string;
    budget?: string;
    timing?: string;
  }) => {
    reachGoal('lp_form_submit', params);
  },
  formError: (form: 'lead' | 'lead_magnet', errors: string[]) => {
    reachGoal('lp_form_error', { form, errors: errors.join(',') });
  },
  faqOpen: (questionId: string) => {
    reachGoal('faq_open', { question_id: questionId });
  },
  scrollDepth: (percent: 50 | 90) => {
    reachGoal(`scroll_${percent}`);
  },
  themeToggle: (from: string, to: string) => {
    reachGoal('theme_toggle', { from, to });
  },
  leadMagnetDownload: (method: 'direct' | 'email_gate') => {
    reachGoal('lead_magnet_download', { method });
  },
};
